import type { ReactNode } from "react";

/** Shared frame for behavior nodes, matching the existing canvas cards. */
export function BehaviorNodeCard({
  children,
  minWidth = 240,
  header,
  headerBackground,
  title,
}: {
  children: ReactNode;
  minWidth?: number;
  header?: ReactNode;
  headerBackground?: string;
  title?: string;
}) {
  return (
    <div
      title={title}
      style={{
        minWidth,
        borderRadius: 8,
        overflow: "hidden",
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(200, 200, 200, 0.98) 100%)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        border: "1px solid #e5e7eb",
      }}
    >
      {header && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: "4px 8px",
            fontSize: 12,
            fontWeight: 700,
            color: "#fff",
            background: headerBackground,
          }}
        >
          {header}
        </div>
      )}
      {children}
    </div>
  );
}
